query VideoDownload($id: ID!) {
  content(id: $id) {
    id
    videoDownload {
      status
      percent
      url
      error
    }
  }
}
